import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { ContainerPlanos } from "./styles";
import PlanTable from '../../components/planTable';
import PlanTableWithCupom from '../../components/planTable/withCupom';

import CountdownBlackLP from '../../components/countdown-black-lp';
import * as S from './styles'
import Logo from '../../assets/logo-agroreceita-black.svg'
import Footer from '../../components/footer';
import { useState } from 'react';
import api from '../../services/api';
import maintainUtm from '../../services/maintainUtm';
import {getCurrentPageIdWithDevice} from "../../services/maintainUtm/idPages";

const Planos = ({ campaign, ...props }) => {
    const [isPromoVisible, setIsPromoVisible] = useState(false);

    const handleBlackNovemberVisibility = (isVisible) => {
        setIsPromoVisible(isVisible);
    };

    useEffect(() => {
        if (!campaign) {
            setIsPromoVisible(false);
            return;
        }
        const currentDate = new Date();
        const baseTarget = new Date(campaign.data_final);
        const targetDate = new Date(baseTarget.getTime() + 3 * 60 * 60 * 1000);
        setIsPromoVisible(currentDate <= targetDate);
    }, [campaign]);

    const redirectLogin = () => {
        const current = new URL(window.location.href);
        props.history.push({ pathname: '/login', search: current.search });
    }

    const redirectCadastro = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-headertestegratis`);
        props.history.push({ pathname: '/cadastro', search: search });
    }

    return (
        <>
            {isPromoVisible && <CountdownBlackLP onVisibilityChange={handleBlackNovemberVisibility} campaign={campaign}/>}

            <ContainerPlanos>
                <S.HeaderPlans>
                    <div class='image'>
                        <a href="https://agroreceita.com.br/">
                            <img src={Logo} alt="Logo AgroReceita" />
                        </a>
                    </div>

                    <div class='links'>
                        <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                        <a href="">Planos</a>
                        <a href="https://agroreceita.com.br/blog/">Blog</a>
                    </div>

                    <div class='buttons-plans'>
                        <button onClick={() => redirectLogin()}>Entrar</button>
                        <button onClick={() => redirectCadastro()}>Teste Grátis</button>
                    </div>

                    <div class='mobile-only'>
                        <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                        <a onClick={() => redirectLogin()}>Entrar</a>
                    </div>
                </S.HeaderPlans>

                {isPromoVisible ? (
                    <PlanTableWithCupom campaign={campaign} />
                ) : (
                    <PlanTable />
                )}

                <Footer />
            </ContainerPlanos>

        </>
    )
}

export default withRouter(Planos);
